function server() {
  // return "http://192.168.1.3/bulksms/";
  return "https://sms.strackit.com/api/v1/";
}

export default server;
